import {
	EmailSentEventStatusResponse,
	InvestorMessageRes,
} from '@dealstack/shared/lib/backendClient';
import {
	DATE_FORMATS,
	formatStringDateToUiWithFallback,
} from '@dealstack/shared/lib/format/dates/date';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

export const mapStatusToIcon = (status: EmailSentEventStatusResponse) => {
	const icons: Record<EmailSentEventStatusResponse, PredefinedIcons> = {
		[EmailSentEventStatusResponse.SENT]: 'lightning-fast-speed',
		[EmailSentEventStatusResponse.FAILED]: 'danger',
		[EmailSentEventStatusResponse.BOUNCED]: 'danger',
		[EmailSentEventStatusResponse.ATTEMPTED]: 'open-book',
		[EmailSentEventStatusResponse.DELIVERED]: 'tick-circle',
		[EmailSentEventStatusResponse.OPENED]: 'open-book',
		[EmailSentEventStatusResponse.CLICKED]: 'cursors',
		[EmailSentEventStatusResponse.CONVERTED]: 'tick-circle',
		[EmailSentEventStatusResponse.SPAM]: 'danger',
		[EmailSentEventStatusResponse.SUPPRESSED]: 'danger',
		[EmailSentEventStatusResponse.UNDELIVERED]: 'danger',
		[EmailSentEventStatusResponse.UNSUBSCRIBED]: 'danger',
		[EmailSentEventStatusResponse.UNKNOWN]: 'question',
	};
	return icons[status];
};

export const hasReadableContent = (message: InvestorMessageRes): boolean =>
	!!message.body ||
	message.sendHistory.some((item) => item.status === EmailSentEventStatusResponse.DELIVERED);

/** The detail view renders the dates as given, so they are formatted where the message is fetched. */
export const formatMessageDates = (message: InvestorMessageRes): InvestorMessageRes => ({
	...message,
	sendDate: message.sendDate
		? formatStringDateToUiWithFallback(message.sendDate, DATE_FORMATS.DATE_TIME_ALT, '')
		: '',
	sendHistory: message.sendHistory.map((item) => ({
		...item,
		createdAt: formatStringDateToUiWithFallback(
			item.createdAt,
			DATE_FORMATS.DATE_TIME_ALT,
			item.createdAt
		),
	})),
});
